import classNames from 'classnames';
import { PureComponent, ReactNode } from 'react';
import './index.scss';

export enum Color {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Info = 'info',
  Default = 'default',
  Warning = 'warning',
  Danger = 'danger',
}

interface Props {
  content: string;
  header: ReactNode;
  headerRight: ReactNode;
  color?: Color | string;
  children?: ReactNode;
  textButtonCollapse?: string;
  textButtonExpand?: string;
  isInitiallyExpanded?: boolean;
  v2: boolean;
}

interface State {
  isExpanded: boolean;
}

class Well extends PureComponent<Props, State> {
  public static defaultProps = {
    color: Color.Default,
    textButtonCollapse: 'hide',
    textButtonExpand: 'view',
    content: '',
    header: '',
    headerRight: '',
    v2: false,
  };

  public state = {
    isExpanded: this.props.isInitiallyExpanded || false,
  };

  private onToggle = () => {
    this.setState(({ isExpanded }) => ({ isExpanded: !isExpanded }));
  };

  private renderContent() {
    const { content, header } = this.props;
    return <div className="Well__title">{content || header}</div>;
  }

  private renderExpandableContent() {
    const { children, content, color, header } = this.props;
    const { isExpanded } = this.state;
    return (
      <div
        className={classNames('ExpandableWell__content', {
          'ExpandableWell__content--bright-font':
            color === Color.Info || color === Color.Secondary,
        })}
      >
        <div className="ExpandableWell__title">
          {content || header}
          {!isExpanded && this.renderExpandButton()}
        </div>
        {isExpanded && (
          <div className="ExpandableWell__children">{children}</div>
        )}
        {isExpanded && this.renderCollapseButton()}
      </div>
    );
  }

  private renderExpandButton = () => (
    <span className="ExpandableWell__expand" onClick={this.onToggle}>
      {this.props.textButtonExpand}
    </span>
  );

  private renderCollapseButton = () => (
    <span className="ExpandableWell__collapse" onClick={this.onToggle}>
      {this.props.textButtonCollapse}
    </span>
  );

  private renderV2() {
    const { header, headerRight, children } = this.props;
    const { isExpanded } = this.state;
    return (
      <div className="ExpandableWell__v2">
        <div className="ExpandableWell__v2-header">
          <span>
            <span
              className="ExpandableWell__v2-expand-button"
              onClick={this.onToggle}
            >
              <i
                className={classNames('mdi', {
                  'mdi-chevron-down': !isExpanded,
                  'mdi-chevron-up': isExpanded,
                })}
              />
            </span>
            <span
              className="ExpandableWell__v2-header-left"
              onClick={this.onToggle}
            >
              {header}
            </span>
          </span>
          <div className="ExpandableWell__v2-header-right">{headerRight}</div>
        </div>
        {isExpanded && (
          <div className="ExpandableWell__v2-content">{children}</div>
        )}
      </div>
    );
  }

  private renderV1() {
    const { children } = this.props;
    if (children) {
      return this.renderExpandableContent();
    } else {
      return this.renderContent();
    }
  }

  public render() {
    const { color, content, header, v2 } = this.props;
    if (!content && !header) {
      throw new Error('Please specify content or header prop');
    }
    return (
      <div className={`Well Well--${color}`}>
        {v2 ? this.renderV2() : this.renderV1()}
      </div>
    );
  }
}

export default Well;
